import React from 'react';
import 'date-fns';
import { CAR_STATUS } from 'src/app/constant/config';
import { Paper } from '@material-ui/core';

const CarStatusBar = ({ statisticVehicleStatus, setCarStatus, carStatus }) => {
  const handleSelectCar = car => {
    if (carStatus === car.value) {
      setCarStatus('');
    } else {
      setCarStatus(car.value);
    }
  };
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        fontSize: '14px',
        lineHeight: '0.5em',
        width: '100%'
      }}
    >
      {CAR_STATUS &&
        CAR_STATUS.map((car, index) => (
          <div style={{ position: 'relative' }} key={index++}>
            <Paper
              className={`CarStatusIcon ${
                carStatus === car.value ? 'CarStatusActive' : ''
              }`}
              onClick={() => handleSelectCar(car)}
            >
              <img
                alt="icon"
                src={`/static/iconSvg/carsv2/${car?.icon}.svg`}
                className={`imageCar`}
              />
            </Paper>
            <br />
            <div style={{ textAlign: 'center' }}>
              <span
                style={{
                  fontSize: '14px',
                  color: 'black',
                  display: 'block',
                  margin: '4px'
                }}
              >
                (
                {index === 0 && statisticVehicleStatus
                  ? statisticVehicleStatus.moving
                  : index === 1 && statisticVehicleStatus
                  ? statisticVehicleStatus.stopped
                  : index === 2 && statisticVehicleStatus
                  ? statisticVehicleStatus.over_speed
                  : index === 3 && statisticVehicleStatus
                  ? statisticVehicleStatus.lost_gps
                  : index === 4 && statisticVehicleStatus
                  ? statisticVehicleStatus.lost_gms
                  : 0}
                )
              </span>
              <br />
              {car?.label}
            </div>
          </div>
        ))}
    </div>
  );
};

export default CarStatusBar;
